import React from "react";
import Layout from "../../layouts/Layout";
import { Box, Typography } from "@mui/material";

const AffiliateDisclosure = () => {
  return (
    <Layout>
      <Box
        sx={{
          px: { xs: 2, md: 8 },
          py: { xs: 4, md: 8 },
          maxWidth: "1200px",
          mx: "auto",
        }}
      >
        {/* Header Section */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography variant="h3" sx={{ fontWeight: 700, mb: 2 }}>
            Affiliate Disclosure
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "text.secondary", maxWidth: "700px", mx: "auto" }}
          >
            At <strong>Handpik.ai</strong>, transparency matters. We want you to
            understand how our platform works and how we earn revenue.
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              maxWidth: "700px",
              mx: "auto",
              mt: 2,
            }}
          >
            <strong>What Handpik.ai is:</strong> Handpik.ai is a smart AI
            shopping assistant. Describe your moment and mood—or upload an inspo
            image—and we surface personalized picks across categories like
            clothing, bags, shoes, watches, accessories, and kids’ toys from
            trusted retailers.
          </Typography>
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2 }}>
          How we earn
        </Typography>
        <Box component="ul" sx={{ pl: 6, mb: 2 }}>
          {[
            "We don’t sell products directly: When you’re ready to buy, you complete your purchase on the retailer’s website.",
            "We may earn an affiliate commission: if you click a product link on Handpik.ai and then make a purchase from that retailer.",
            "No extra cost to you: The price you pay at the retailer is the same whether or not we earn a commission.",
          ].map((item, i) => {
            const [boldPart, rest] = item.split(":");
            return (
              <Typography
                key={i}
                component="li"
                sx={{ mb: 1, color: "text.secondary" }}
              >
                •{" "}
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  {boldPart}:
                </Typography>{" "}
                {rest.trim()}
              </Typography>
            );
          })}
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
          About product information
        </Typography>
        <Box component="ul" sx={{ pl: 6, mb: 2 }}>
          {[
            "Details come from retailers: Pricing, promotions, availability, sizing, shipping, and return/warranty terms are provided by the retailer and may change without notice.",
            "Check before you buy: We work to keep information accurate, but the retailer’s website always has the final word.",
          ].map((item, i) => {
            const [boldPart, rest] = item.split(":");
            return (
              <Typography
                key={i}
                component="li"
                sx={{ mb: 1, color: "text.secondary" }}
              >
                •{" "}
                <Typography component="span" sx={{ fontWeight: 600 }}>
                  {boldPart}:
                </Typography>{" "}
                {rest.trim()}
              </Typography>
            );
          })}
        </Box>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
          Editorial independence
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
          Our recommendations are driven by relevance to your request (fit,
          fabric, style, heat-friendliness, modest options, etc.). Affiliate
          relationships don’t require us to recommend a specific product, and
          they don’t increase your price.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
          Tracking & cookies (brief)
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
          To attribute purchases, retailers or their affiliate networks may use
          cookies or similar technologies after you click out from Handpik.ai.
          If tracking is blocked or overwritten, we may not earn commission—this
          does not affect your price.
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
          Your acknowledgement
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
          By using Handpik.ai, you understand that we help you discover products
          and deals; the{" "}
          <strong>final transaction is always with the retailer.</strong>
        </Typography>

        <Typography variant="h5" sx={{ fontWeight: 600, mb: 2, mt: 4 }}>
          Questions?
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "text.secondary" }}>
          Email us at{" "}
          <Typography
            component="a"
            href="mailto:info@handpik.ai"
            sx={{
              color: "#FF7A00",
              textDecoration: "none",
              fontWeight: 500,
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            info@handpik.ai
          </Typography>
        </Typography>
      </Box>
    </Layout>
  );
};

export default AffiliateDisclosure;
